import { useMemo } from 'react';
import { getLocalDateInfo } from '@/utils/dates';
import Container from '@ui/container/container';
import CalendarDay from '@/micros/shared-create-and-edit-components/grid-areas/main/project-overview/project-runtime/calendar-day';
import DateDescription from '@/micros/shared-create-and-edit-components/grid-areas/main/project-overview/project-runtime/date-description';
import SelectedBroadcastTypePill from '@/micros/shared-create-and-edit-components/grid-areas/main/project-overview/broadcast-type-picker/selected-broadcast-type-pill';
import { Session } from '@/types/session.types';
import getSelectedBroadcastType from './helpers/get-selected-broadcast-type';

type TUnFocusedSessionInfoProps = {
  session?: Session | null;
  selectedDates: {
    startDate: number | null;
    endDate: number | null;
    selectedTimezone: string;
  };
  isFocusedWithin: boolean;
};

const UnfocusedSessionInfoContent = ({ isFocusedWithin, selectedDates, session }: TUnFocusedSessionInfoProps) => {
  const startTimestamp = session?.timestamp;
  const endTimestamp = session?.end_timestamp;

  const dates = useMemo(() => {
    return getLocalDateInfo({ startTimestamp, endTimestamp, selectedTimezone: selectedDates.selectedTimezone });
  }, [startTimestamp, endTimestamp, selectedDates.selectedTimezone]);

  return (
    <Container
      height="84px"
      width="100%"
      borderRadius="8px"
      padding="12px"
      className="flex ai-center jc-flex-start"
      opacity={isFocusedWithin ? 0 : 1}
      transitionDuration="0ms"
      data-component="UnfocusedSessionInfoContent"
    >
      <Container className={`flex ai-center jc-flex-start gap-12`} height="100%" width="100%">
        <Container className={`flex ai-center jc-flex-start gap-12`} height="100%" width="100%">
          <div>
            <CalendarDay dates={dates} />
          </div>
          <div>
            <DateDescription dates={dates} displayTimezone={true} />
          </div>
        </Container>

        <Container minWidth="max-content" className="margin-r-0 margin-l-auto">
          <SelectedBroadcastTypePill broacastType={getSelectedBroadcastType(session)} />
        </Container>
      </Container>
    </Container>
  );
};

export default UnfocusedSessionInfoContent;
